import { render, staticRenderFns } from "./OrderFabricExtraProcessTypeTable.vue?vue&type=template&id=7473b7c3&scoped=true&"
import script from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473b7c3",
  null
  
)

export default component.exports